'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { Calendar, Users, Search } from 'lucide-react';

export default function SearchWidget() {
  const [checkIn, setCheckIn] = useState('');
  const [checkOut, setCheckOut] = useState('');
  const [guests, setGuests] = useState('2');

  const today = new Date()?.toISOString()?.split('T')?.[0];

  return (
    <section
      className="relative z-10 bg-white"
      style={{
        borderBottom: '1px solid #E2DDD6',
        boxShadow: '0 4px 24px rgba(11,22,40,0.07)',
      }}
    >
      {/* Subtle gold top line */}
      <div className="h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(201,169,110,0.4), transparent)' }} />
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-12 py-6">
        <div className="flex flex-col lg:flex-row items-end gap-4">
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-3 gap-4 w-full">
            {/* Check-in */}
            <div>
              <label
                className="flex items-center gap-1.5 text-xs font-semibold text-[#6B6560] tracking-widest uppercase mb-2"
                style={{ letterSpacing: '0.12em' }}
              >
                <Calendar size={11} className="text-[#C9A96E]" />
                Check-in
              </label>
              <input
                type="date"
                value={checkIn}
                onChange={(e) => setCheckIn(e?.target?.value)}
                className="input-field"
                min={today}
              />
            </div>

            {/* Check-out */}
            <div>
              <label
                className="flex items-center gap-1.5 text-xs font-semibold text-[#6B6560] tracking-widest uppercase mb-2"
                style={{ letterSpacing: '0.12em' }}
              >
                <Calendar size={11} className="text-[#C9A96E]" />
                Check-out
              </label>
              <input
                type="date"
                value={checkOut}
                onChange={(e) => setCheckOut(e?.target?.value)}
                className="input-field"
                min={checkIn || today}
              />
            </div>

            {/* Guests */}
            <div>
              <label
                className="flex items-center gap-1.5 text-xs font-semibold text-[#6B6560] tracking-widest uppercase mb-2"
                style={{ letterSpacing: '0.12em' }}
              >
                <Users size={11} className="text-[#C9A96E]" />
                Guests
              </label>
              <select
                value={guests}
                onChange={(e) => setGuests(e?.target?.value)}
                className="input-field"
              >
                {[1, 2, 3, 4, 5, 6, 7, 8]?.map((n) => (
                  <option key={`guests-${n}`} value={n}>
                    {n} Guest{n !== 1 ? 's' : ''}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <Link
            href={`/apartments-listing${checkIn ? `?checkIn=${checkIn}&checkOut=${checkOut}&guests=${guests}` : ''}`}
            className="inline-flex items-center justify-center gap-2 px-8 py-3 font-semibold text-xs tracking-widest uppercase w-full lg:w-auto whitespace-nowrap btn-scale transition-all hover:brightness-110"
            style={{
              background: '#C9A96E',
              color: '#050D1A',
              borderRadius: '2px',
              letterSpacing: '0.12em',
              boxShadow: '0 2px 12px rgba(201,169,110,0.25)',
            }}
          >
            <Search size={14} />
            Search
          </Link>
        </div>
      </div>
    </section>
  );
}